import CustomTypography from "@/components/Typography/CustomTypography";
import { Tooltip } from "antd";

interface PriceQuoteRatingProps {
  value: "L1" | "L2" | "L3" | undefined;
}

export default function PriceQuoteRating({ value }: PriceQuoteRatingProps) {
  if (value === "L1") {
    return (
      <Tooltip title="Cheapest">
        <CustomTypography
          color={"green"}
          className="w-5 h-5 rounded-[4px] bg-success-light flex justify-center items-center"
        >
          {value}
        </CustomTypography>
      </Tooltip>
    );
  }
  if (value === "L2") {
    return (
      <Tooltip title="Average">
        <CustomTypography
          color={"yellow"}
          className="w-5 h-5 rounded-[4px] bg-yellow-main flex justify-center items-center"
        >
          {value}
        </CustomTypography>
      </Tooltip>
    );
  }
  if (value === "L3") {
    return (
      <Tooltip title="Most expensive">
        <CustomTypography
          color={"error"}
          className="w-5 h-5 rounded-[4px] bg-red-light flex justify-center items-center"
        >
          {value}
        </CustomTypography>
      </Tooltip>
    );
  }
  return null;
}
